import config from '../../config/config';
import { getStore } from '../../store';
import { rendererHeaders } from '../helpers/app-services/AppServices/index';
import * as tokenHelper from '../helpers/TokenHelper';
import { rateLimitedfetch } from '../helpers/requestLimiter';

const { CHECKOUT_API_URL } = config;

export const fetchWithApiToken = (path, token, method = 'GET', headers = {}, body) => {
  if (token) {
    headers['x-spk-auth-token'] = token;
  }
  return rateLimitedfetch(`${CHECKOUT_API_URL}${path}`, {
    method,
    headers: { ...headers },
    body: JSON.stringify(body)
  }).then(res => res.json());
};

export const getCheckoutInfo = (licenceType, countryCode, currencyCode, state = null, postcode = null) => {
  const { auth } = getStore().getState();
  const { token } = auth.currentUser;
  const authToken = token || tokenHelper.getSparkolToken();
  const headers = rendererHeaders(true);
  const url = `/api/checkout?licenceType=${licenceType}&countryCode=${countryCode}&currencyCode=${currencyCode}&state=${state}&postcode=${postcode}`;

  return fetchWithApiToken(url, authToken, 'GET', headers);
};
